import React from "react";
import { Survey, SurveyReportDataSet, SurveySegment, surveyHelper } from "../../../../../../../amorg-common";
import { Flex } from "../../../../../../../designSystem/compositeComponents/FlexHelpers";
import { PageSection } from "../../../../../../../designSystem/PageSection";
import { ReportSummarySection } from "../../_components/ReportSummarySection";
import { IndicatorPanel } from "./IndicatorPanel";
import { ThemePanel } from "./ThemePanel";

type SurveyReportPanelProps = {
    survey: Survey,
    siteId:string,
    data:SurveyReportDataSet,
    segments:SurveySegment[][]
    showComments: boolean,
};
export function SurveyReportPanel (props: SurveyReportPanelProps): JSX.Element
{
    const hasLoaded = props.survey && props.data;
    const hasQuestions = hasLoaded && surveyHelper.getAllSurveyQuestions(props.survey).length > 0;

    return (
        <>
            {hasLoaded && hasQuestions &&
                <>
                    <Flex flexDirection="column" gap={16}>

                        <ReportSummarySection survey={props.survey} data={props.data} expandable />

                        {props.survey.themes.some(t => t.questions.some(q => q.indicators.length > 0)) &&
                            <PageSection
                                header={{ title: 'Indikatorer', defaultCollapsed: false }}>
                                <IndicatorPanel
                                    survey={props.survey}
                                    siteId={props.siteId}
                                    data={props.data.indicatorData}
                                    segmentFilter={props.segments}
                                    showComments={props.showComments} />
                            </PageSection>
                        }

                        <PageSection
                            header={{ title: 'Spørgsmål fordelt på Tema',
                                defaultCollapsed: false
                             }}>

                            <ThemePanel
                                survey={props.survey}
                                siteId={props.siteId}
                                themes={props.data.themeData}
                                segmentFilter={props.segments}
                                showComments={props.showComments} />
                        </PageSection>
                    </Flex>
                </>
            }
        </>
    );
}